// extracted by mini-css-extract-plugin
module.exports = {"container":"CA","vocBtn":"DA","disabled":"EA"};